import { nextTick } from 'vue'

export function useScrollToElementBelowHeader(getHeaderHeight: () => number) {
  /**
   * Scroll the element just below the dynamic sticky header.
   * @param el - Element to scroll to
   */
  const scrollTo = async (el: HTMLElement | null) => {
    if (!el) return

    await nextTick()

    const headerHeight = getHeaderHeight()
    const rect = el.getBoundingClientRect()
    const scrollTop = document.documentElement.scrollTop
    const offsetTop = rect.top + scrollTop - headerHeight

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    })
  }

  return {
    scrollTo,
  }
}
